import * as Yup from 'yup';

export const SUPERADMIN = 1;
export const ADMIN_PROJECT = 11;

export const initialValues = {
  name: '',
  email: '',
  password: '',
  confirm_password: '',
  role: SUPERADMIN,
  project: undefined
};

export const userSchema = Yup.object().shape({
  name: Yup.string().required("Nama harus diisi").nullable(true),
  email: Yup.string().email("Email yang Anda masukkan tidak sesuai").required("Email harus diisi").nullable(true),
  // password: Yup.string().required("Password harus diisi").nullable(true),
  // confirm_password: Yup.string().oneOf([Yup.ref('password'), null], "Konfirmasi password tidak cocok").required('Konfirmasi password harus diisi'),
  role: Yup.mixed().required("Jenis user harus dipilih").nullable(true),
  project: Yup.mixed().when('role', {
    is: value => value === ADMIN_PROJECT,
    then: Yup.mixed().required("Proyek harus dipilih").nullable(true),
    otherwise: Yup.mixed().nullable(true)
  })
});

export const updateUserSchema = Yup.object().shape({
  name: Yup.string().required("Nama harus diisi").nullable(true),
  email: Yup.string().email("Email yang Anda masukkan tidak sesuai").required("Email harus diisi").nullable(true),
  status: Yup.mixed().required('Status harus diisi'),
  // password: Yup.string().nullable(true),
  // confirm_password: Yup.string().oneOf([Yup.ref('password'), null], "Konfirmasi password tidak cocok"),
  role: Yup.mixed().required("Jenis user harus dipilih").nullable(true),
  project: Yup.mixed().when('role', {
    is: value => value === ADMIN_PROJECT,
    then: Yup.mixed().required("Proyek harus dipilih").nullable(true),
    otherwise: Yup.mixed().nullable(true)
  })
});